import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography
} from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { bool, func } = proptypes;

export const ProHouseAccountWarning = ({
  openModal = false,
  handleCloseModal
}) => {
  return (
    <Modal open={openModal} onClose={handleCloseModal} size="sm">
      <ModalHeader onClose={handleCloseModal}>
        Deletion Not Allowed
      </ModalHeader>
      <ModalBody>
        <div className="sui-grid sui-gap-4">
          <Typography variant="body-xs">
            This project is linked to a Pro House account and cannot be deleted.
          </Typography>
        </div>
      </ModalBody>
      <ModalFooter position="end">
        <Button variant="primary" fullWidth onClick={handleCloseModal}>OK</Button>
      </ModalFooter>
    </Modal>
  );
};

ProHouseAccountWarning.displayName = 'ProHouseAccountWarning';
ProHouseAccountWarning.propTypes = {
  openModal: bool,
  handleCloseModal: func.isRequired
};

ProHouseAccountWarning.defaultProps = {
  openModal: false
};
